// extracted by mini-css-extract-plugin
module.exports = {"inputMerchantStoreId":"merchnat-store-id_inputMerchantStoreId__2ejQx"};